import React from 'react'
import { useQueryClient } from 'react-query'

import { DeactivateButton } from 'components/configurations/common/DeactivateButton'
import useAuth from 'hooks/use-auth'
import { integrationClientsQueryKeys } from 'queries/integration-clients/query-keys'
import { useDeleteIntegrationClients } from 'queries/integration-clients/use-delete-integration-clients'
import { type PrivateNetworkIntegrationClient } from 'types/api/integration-clients/integration-clients'
import { integrationClientsIdDelete } from 'utils/endpoints-access'

export const DeactivatePrivateNetworkIntegrationButton: React.FC<{
  integrationClient: PrivateNetworkIntegrationClient
}> = ({ integrationClient }) => {
  const { currentTeamId: teamId } = useAuth()
  const queryClient = useQueryClient()

  const { identifier } = integrationClient

  const { mutateAsync: mutateDeactivateIntegrationClient } =
    useDeleteIntegrationClients(integrationClient.identifier)

  const handleSuccess = async () => {
    await queryClient.invalidateQueries(
      integrationClientsQueryKeys.get({ teamId })
    )
  }

  return (
    <DeactivateButton
      apiProp={integrationClientsIdDelete}
      dialogTitle="Deactivate Private Network Integration"
      id={identifier}
      onConfirmRequest={mutateDeactivateIntegrationClient}
      onSuccess={handleSuccess}
    />
  )
}
